import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast bg-gray-900 text-white border-2 border-gray-700 shadow-lg text-lg min-w-[450px] max-w-[600px] p-6 rounded-lg",
          title: "group-[.toast]:text-2xl group-[.toast]:font-bold group-[.toast]:mb-3 group-[.toast]:text-red-400 group-[.success]:text-green-400 group-[.info]:text-blue-400",
          description: "group-[.toast]:text-gray-200 group-[.toast]:text-lg group-[.toast]:leading-relaxed group-[.toast]:font-medium",
          error: "group-[.toast]:border-red-500",
          success: "group-[.toast]:border-green-500",
          info: "group-[.toast]:border-blue-500",
        },
      }}
      {...props} />
  );
}

export { Toaster }
